<template>
  <router-link
    :to="to"
    :class="[
      'ob1-link-icon',
      'pr-1',
      { 'o-link-reverse': darkMode },
      { 'ob1-disabled': disabled },
      { 'ob1-link-dark': black }
    ]">
    <span
      :class="[
        'icon',
        `${iconName}`
      ]"
      aria-hidden="true" />
    <span
      class="ob1-link-icon-text">
      {{ label }}
    </span>
    <span
      v-if="srLabel"
      class="sr-only">
      {{ srLabel }}
    </span>
  </router-link>
</template>

<script>
export default {
  name: 'IconLink',
  props: {
    label: {
      type: String,
      required: true
    },
    to: {
      type: [Object, String],
      required: true
    },
    iconName: {
      type: String,
      required: true
    },
    srLabel: {
      type: String,
      default: null
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    black: {
      type: Boolean,
      default: false
    }
  }
}
</script>
